import React, { useState } from 'react';
import { Col, Row, Skeleton } from 'antd';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Config } from '../../utils/config';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';

import { Flex } from 'antd';
import { isDesktop } from 'react-device-detect';

const CardDetail = () => {
    const loading = useSelector((state) => state.home.loading);
    const location = useLocation();
    const { data } = location.state || {};
    const [photos] = useState(data.images.map((item) => {
        var model = { src: Config.CDN_URL + item.path, description: item.description }
        return model

    }));

    const overlayRender = (e) =>  (
        <div style={{ position: 'absolute', left: 0, bottom: 0, padding: 2, width: '100%', minHeight: 24, zIndex: 50, backgroundColor: 'black' }}>
            <p style={{ fontSize: 18, fontWeight: 'bold', fontFamily: 'Roboto', color: 'white',textAlign:'center' }}> 
                {photos[e.index].description}
             </p>
        </div>
    )


    return (
        <> {loading ? (<Skeleton />) :
            (
                <Col span={24}>
                    <p style={{ fontSize: 18, fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 5 }}>{data?.name}</p>
                    <p style={{ fontSize: 16, fontFamily: 'Roboto' }} dangerouslySetInnerHTML={{ __html: data.headerText }}></p>
                    <Flex justify='center' align='center' vertical gap={'large'} style={{ margin: 50 }}>
                        <PhotoProvider overlayRender={(e) => overlayRender(e)} >
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                {photos.map((photo, index) => (
                                    <PhotoView key={index} src={photo.src} >
                                        <img src={photo.src} alt={`Photo ${index + 1}`}
                                            style={{ cursor: 'pointer', width: isDesktop ? '450px' : '95%', height: '300px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }}
                                        />
                                    </PhotoView>

                                ))}
                            </div>
                        </PhotoProvider>
                    </Flex>

                    {data?.videos && data?.videos.length > 0 && (
    <>
        <p style={{ fontSize: 18, fontWeight: 'bold', fontFamily: 'Roboto' }}>Videolar</p>
        {data.videos.map((video, index) => {
            // Her iki video iframe'ini bir Row bileşenine yerleştir
            if (index % 2 === 0) {
                return (
                    <Row key={index} style={{ justifyContent: 'center' }}>
                        <iframe
                            style={{ margin: 10 }}
                            width="853"
                            height="480"
                            src={`${video.url}`}
                            allowFullScreen
                            title={`Embedded youtube ${video.description}`}
                        />
                        {data.videos[index + 1] && (
                            <iframe
                                style={{ margin: 10 }}
                                width="853"
                                height="480"
                                src={`${data.videos[index + 1].url}`}
                                allowFullScreen
                                title={`Embedded youtube ${data.videos[index + 1].description}`}
                                />
                        )}
                    </Row>
                );
            }
            return null;
        })}
    </>
)}
                </Col>
            )}

        </>


    );
};
export default CardDetail;